import { render, staticRenderFns } from "./projectreportdetails.vue?vue&type=template&id=bac1ccea&"
import script from "./projectreportdetails.vue?vue&type=script&lang=js&"
export * from "./projectreportdetails.vue?vue&type=script&lang=js&"
import style0 from "./projectreportdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
